import { render } from "./TheFooter.vue?vue&type=template&id=f8ba99c8&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=f8ba99c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f8ba99c8"

export default script